import axios, { AxiosRequestConfig } from 'axios';
import store from './../store/root/store.config';
import {
  INotification,
  ENotification,
  IError,
} from '../domain/notification.interface';
import {
  decrementLoading,
  incrementLoading,
  returnNotification,
} from './../store/render-controller/render-controller.actions';
import moment from 'moment';
import { EErrorName } from '../domain/notification.interface';

export const httpTimeout = 25000;
export const httpDateFormat = 'YYYY-MM-DDTHH:mm:ssZZ';

const httpInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

httpInstance.defaults.headers = { 'Content-type': 'application/json' };
httpInstance.defaults.timeout = httpTimeout;

const requestHandler = async (request: AxiosRequestConfig) => {
  if (store) {
    const token = store.getState().currentUserReducer.token;
    if (!!token) {
      request.headers['Authorization'] = `Bearer ${token}`;
    }
    if (!request.headers.silently) {
      store.dispatch(incrementLoading());
    }
    delete request.headers.silently;
  }
  return requestHandler2(request);
};

const requestHandler2 = async (request: AxiosRequestConfig) => {
  if (!request.data) {
    return request;
  }
  Object.keys(request.data).forEach((key: any) => {
    if (request.data[key] instanceof Date) {
      request.data[key].setHours(23, 59);
      request.data[key] = moment(request.data[key]).format(httpDateFormat);
    }
  });
  return request;
};

const errorHandler = (error: { response: IError }) => {
  const notification: INotification = {
    type: ENotification.ERROR,
    msg1: '',
    status: undefined,
  };
  if (!error.response) {
    notification.msg1 = 'error.generic';
    notification.status = 500;
    return notificationHandler(notification);
  }
  if (error.response.status >= 400) {
    notification.msg1 =
      error.response.data.exceptionName in EErrorName
        ? `error.${error.response.data.exceptionName}`
        : 'error.generic';
    notification.status = error.response.status;
    return notificationHandler(notification);
  }
};

const notificationHandler = (notification: INotification) => {
  if (store) {
    store.dispatch(decrementLoading());
    store.dispatch(returnNotification(notification));
  }
  return Promise.reject({ ...notification });
};

const successHandler = (response: any) => {
  if (store) {
    store.dispatch(decrementLoading());
  }
  return response;
};

httpInstance.interceptors.request.use(async request => requestHandler(request));
httpInstance.interceptors.response.use(
  response => successHandler(response.data),
  error => errorHandler(error),
);

export default httpInstance;
